export default __webpack_public_path__ + "static/media/carousel-prev.b3509931.svg";